import HttpClient from '../services/HttpClient'
import {
   ACTIVE_GROUPS_PATH,
   SEARCH_GROUPS_PATH,
   ASSIGN_GROUP_PATH,
   GROUPS_PATH
} from '../constants'

export const getAllActiveGroupsApi = (query = '') => {
   const params = { request: query }
   return HttpClient.get(
      `${process.env.REACT_APP_GROUPS_API}${ACTIVE_GROUPS_PATH}`,
      { params }
   )
      .then(response => response.data)
      .catch(err => Promise.reject(err))
}

export const getFilteredGroupsApi = urlParams => {
   return HttpClient.get(
      `${process.env.REACT_APP_GROUPS_API}${SEARCH_GROUPS_PATH}?${urlParams}`
   )
      .then(response => response.data)
      .catch(err => Promise.reject(err))
}

export const saveGroup = formData => {
   return new Promise((resolve, reject) => {
      const headers = {
         'Content-Type': 'application/json'
      }
      HttpClient.post(
         `${process.env.REACT_APP_GROUPS_API}${GROUPS_PATH}`,
         formData,
         headers
      )
         .then(response => {
            resolve(response)
         })
         .catch(error => {
            if (typeof error.response === 'undefined') {
               console.log('A network error occurred. ')
               reject({
                  error: 'technical_error',
                  error_description:
                     'Ocurrió un problema comuniquese con el administrador.'
               })
            }
            resolve(error.response)
         })
   })
}

export const assignGroupToRolesAndUsersApi = (groupId, groupPayload) => {
   return HttpClient.post(
      `${process.env.REACT_APP_GROUPS_API}${GROUPS_PATH}/${groupId}${ASSIGN_GROUP_PATH}`,
      groupPayload
   )
      .then(response => response.data)
      .catch(err => Promise.reject(err))
}
